import { ReactNode } from 'react';

import { FullHeightContainer } from 'components/FullHeightContainer';
import { Alert, Row } from 'components/Blocks';

import { useAuth } from 'providers/Auth';

import { APP_WRAPPER_ID } from 'utils/constants';

import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { AppWrapperProvider } from './WrapperContext';
import { ForceBugContextModal } from 'pages/Feedback/components';
import { useIsOnline } from 'hooks/online';

interface WrapperProps {
  children: ReactNode;
}

export function AppWrapper({ children }: WrapperProps) {
  const { loginAction } = useAuth();

  const isOnline = useIsOnline();

  if (loginAction) return <>{children}</>;

  return (
    <>
      <AppWrapperProvider>
        <div className="flex h-full flex-col">
          <Header />

          {!isOnline && (
            <Alert
              title="You are offline"
              className="justify-center rounded-none p-1"
              type="filled"
              level="warning"
            />
          )}

          <Row gap="2" alignItems="stretch" className="h-full">
            <FullHeightContainer
              // Force recalculation
              key={`${isOnline}`}
              className="flex w-full flex-1"
              manageOverflow={false}
            >
              <Sidebar />

              <div
                id={APP_WRAPPER_ID}
                className="scrollbar flex w-full flex-col overflow-y-auto px-8 py-4 phone:px-4"
              >
                {children}
              </div>
            </FullHeightContainer>
          </Row>
        </div>
      </AppWrapperProvider>

      <ForceBugContextModal />
    </>
  );
}
